export const YANDEX_METRIKA_COUNTER_ID = 110623938;

export type MetrikaGoal = 'registratsiya_forma' | 'vhod_v_lk';

export const reachGoal = (goalName: MetrikaGoal, params?: Record<string, unknown>): void => {
  if (typeof window === 'undefined' || typeof window.ym !== 'function') return;

  try {
    if (params) {
      window.ym(YANDEX_METRIKA_COUNTER_ID, 'reachGoal', goalName, params);
    } else {
      window.ym(YANDEX_METRIKA_COUNTER_ID, 'reachGoal', goalName);
    }
  } catch {
    return;
  }
};